export default __webpack_public_path__ + "images/package_icon.79ca8d6.svg";